export default function FinanceApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    // Process a fiscal period
    function processFiscalPeriod(fiscalPeriod) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/finance/ProcessFiscalPeriod?fiscalPeriod=${fiscalPeriod}`));
        });
    }

    // Close a fiscal period
    function closeFiscalPeriod(fiscalPeriod) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/finance/closeFiscalPeriod?fiscalPeriod=${fiscalPeriod}`));
        });
    }

    // get fiscal periods
    function getFiscalPeriods() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/finance/getFiscalPeriods`));
        });
    }

    function closePayRun(){
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/finance/closePayRun`));
        });
    }

    function reprocessPayRun(){
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/finance/reprocessPayRun`));
        });
    }


    return {
        processFiscalPeriod,
        closeFiscalPeriod,
        getFiscalPeriods,
        closePayRun,
        reprocessPayRun
    };
}
